import React, { useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import TitleDashboard from '../Titles/TitleDashboard'
import getFechaSinHora from '@helpers/dates/getDateFinalizacionCurso/getFechaSinHora';
const ReciboPagos = () => {

    const [fechaExpedicion, setFechaExpedicion] = useState(1760999470);

    useEffect(() => {

        const param = new URLSearchParams(window.location.search);

		const fechaPago = param.get("date");

        if(fechaPago) {
            console.log('fechaPago');
            setFechaExpedicion(fechaPago);
        }

        document.body.classList.add('no-scroll');
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, []);
    return (
        <Container className="mb-5">
            <Row className='justify-content-center'>
                <Col style={{ background: "#f2f2f2a2", borderRadius: "10px" }} className="col-12 col-md-10 col-lg-8 my-0 my-md-5 p-3 p-md-5 shadow">
                    <Row>
                        <Col>
                            <TitleDashboard title={"Recibo de pago"} />
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col className='col-12 text-center'>
                            <h3 className='text-center text-md-start'>Se expide este recibo a la compra del servicio: </h3>
                            <Image className='mt-4 mb-3' src={require("@assets/images/click.png")} width={"200"} alt='Global Click Mexico' />
                            <p style={{ fontSize: "22px", fontWeight: 'bold' }}>Curso en linea Lectura Inteligente</p>
                        </Col>
                        <Col className='col-12'>
                            <h4>Imparte:</h4>
                            <p>- Global Click México</p>

                            <h4>Duración del curso:</h4>
                            <p>14 semanas</p>

                            <h4>Objetivo del curso:</h4>
                            <p>
                                Desarrollar en el participante la capacidad de incrementar su velocidad lectora hasta 1,200 palabras por minuto, mejorando simultáneamente su nivel de comprensión y retención de la información. Al finalizar el curso, el alumno será capaz de procesar textos con mayor eficiencia, optimizar su aprendizaje y elevar su productividad personal y profesional.
                            </p>

                            <h4>Instructor del curso:</h4>
                            <p>Oswaldo Jiménez Valerio</p>

                            <h4>Facilitador:</h4>
                            <p>José Leonardo Merchán Vanegas</p>

                            <h4>Valor:</h4>
                            <p>$1285.00 mxn</p>

                            <h4>Status:</h4>
                            <p><span className='text-success' style={{ fontSize: '22px',fontWeight: 'bold' }}>Pagado</span></p>

                            <h4>Expedición:</h4>
                            <p>{getFechaSinHora(fechaExpedicion)}</p>

                        </Col>

                    </Row>

                    <Row className="justify-content-center mt-5">
                        <Col className="col-auto text-center">
                            <Image className='mt-4 mb-3' src={require("@assets/images/logo-gc-horizontal.png")} width={"150"} alt='Global Click Mexico' />
                            <p style={{color: "gray", marginTop: '5px', fontWeight: 'bold'}}>Departamento de contabilidad <br/> Global Click México | 2025</p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

export default ReciboPagos